import React from "react";
import { cn } from "@/lib/utils";
import { X } from "lucide-react";

export function CrossFilterChip({ label, value, onClear, testId, className }) {
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center gap-2 rounded-full border bg-[hsl(var(--surface-2))] px-3 py-1 text-xs font-medium",
        className
      )}
    >
      {label && <span className="text-muted-foreground">{label}:</span>}
      <span className="text-foreground">{value}</span>
      {onClear && (
        <button
          onClick={onClear}
          aria-label="Clear filter"
          className="rounded-full p-0.5 text-muted-foreground transition-colors hover:bg-[hsl(var(--surface-3))] hover:text-foreground"
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </span>
  );
}
